module.exports = __webpack_public_path__ + "static/media/question.672a170b.png";